<template>
  <div
    v-if="allTransactions.data && allTransactions.data.length"
    class="data-grid"
  >
    <h2 class="cc-sub-title">
      Transactions Associated{{
        clientId !== undefined || clientSftpId !== undefined
          ? " with Folder"
          : ""
      }}
    </h2>
    <div class="paging-container">
      <div class="total-items paging-total">
        Total: <span>{{ formatThousandDecimal(pagination.total) }}</span>
      </div>
      <div class="dt-paging paging-control">
        <div class="select-page-number">
          <b-pagination
            @change="changePageOptions"
            size="md"
            :total-rows="pagination.total"
            v-model="pagination.page"
            :per-page="parseInt(pagination.limit)"
          >
          </b-pagination>
        </div>
        <b-form-group
          horizontal
          :label-cols="6"
          label="Per page"
          class="item-per-page"
        >
          <b-form-select
            @change="changeItemPerPageOptions"
            :options="pageOptions"
            v-model="pagination.limit"
          />
        </b-form-group>
      </div>
    </div>
    <div class="datatable-table-wrapper table-responsive">
      <b-table
        bordered
        hover
        class="datatable-table"
        :items="allTransactions.data"
        :fields="fields"
        :busy="isLoadingList"
      >
        <template #cell(no)="data">{{ data.index + 1 }}</template>
        <template #cell(file_name)="data">
          <!--<span class="file-name" :style="{cursor: canDownloadFile ? 'pointer' : 'inherit'}" :title="data.value">-->
          <span class="file-name" :title="data.value">
            <!--<u @click="downloadFileUpload(data)">{{ data.value }}</u>-->
            {{ data.value }}
          </span>
        </template>

        <template #cell(method)="data">{{ getMode(data) }}</template>
        <template #cell(type)="data">{{
          getValueByKey(consts.typeOptions, data.value).text
        }}</template>
        <template #cell(data_type)="data">{{
          getValueByKey(consts.dataTypeOptions, data.value).text
        }}</template>
        <template #cell(status)="data">
          <template
            v-for="fileProcessing in constCommon.fileProcessing"
            v-if="data.item.status === fileProcessing.code"
          >
            <TransactionStatus :statusObj="fileProcessing" :data="data" />
          </template>
        </template>
        <template #cell(created_date)="data">{{
          data.value | timezone(userInfo.timezone)
        }}</template>
      </b-table>
    </div>
    <div class="paging-container">
      <div class="dt-paging paging-control">
        <div class="select-page-number">
          <b-pagination
            @change="changePageOptions"
            size="md"
            :total-rows="pagination.total"
            v-model="pagination.page"
            :per-page="parseInt(pagination.limit)"
          >
          </b-pagination>
        </div>
        <b-form-group
          horizontal
          :label-cols="6"
          label-size="sm"
          label="Per page"
          class="item-per-page"
        >
          <b-form-select
            :options="pageOptions"
            @change="changeItemPerPageOptions"
            v-model="pagination.limit"
          />
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DataTable from "@/components/datatable/DataTable";
import TransactionStatus from "@/components/transaction-associated/TransactionStatus";
import consts from "@/_consts";
import {
  GETTERS_TRANSACTION_LIST,
  GETTERS_TRANSACTION_LIST_LOADING,
  ACTION_GET_TRANSACTION_LIST
} from "@/store/modules/transactions/constants";
import { GETTER_USER_INFO } from "@/store/modules/users/constants";
import { ACTION_DOWNLOAD_FILE_UPLOAD } from "@/store/modules/files_processing/constants";
export default {
  name: "c-transaction-associated",
  components: {
    DataTable,
    TransactionStatus
  },
  props: {
    clientSftpId: [String, Number],
    clientId: [String, Number],
    isReloadData: {
      type: Boolean,
      default: false
    },
    canDownloadFile: {
      type: Boolean,
      default: true
    },
    selectedClientPanelId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      modalData: {
        action: consts.modalAction.showProcessingFileErrorList,
        data: null,
        okClickHandle: null
      },
      fields: [
        "no",
        "file_name",
        { key: "method", label: "Mode" },
        "type",
        "data_type",
        { key: "file_path", class: "trans-file-path-col text-truncate" },
        { key: "status", class: "trans-status" },
        { key: "created_date", label: "Last Processed" }
      ],
      consts: consts,
      pagingObj: {
        page: 1,
        limit: 5,
        orderBy: "created_at",
        sortedBy: "desc",
        search: "",
        customSearch: "",
        total: 0,
        searchJoin: "and"
      },
      pageOptions: [5, 10, 15, 20, 50, 100]
    };
  },
  computed: {
    constCommon() {
      this.allTransactions.data.map(s => {
        if (s.is_tested === 1) {
          s.method = s.method + " (test)";
        }
      });
      return consts;
    },
    pagination() {
      if (typeof this.allTransactions.meta === "undefined") {
        return this.pagingObj;
      }
      this.pagingObj.total = this.allTransactions.meta.pagination.total;
      this.pagingObj.page = this.allTransactions.meta.pagination.current_page;
      return this.pagingObj;
    },
    ...mapGetters({
      userInfo: GETTER_USER_INFO,
      allTransactions: GETTERS_TRANSACTION_LIST,
      isLoadingList: GETTERS_TRANSACTION_LIST_LOADING
    })
  },
  methods: {
    getMode(data) {
      if (data.item.data_type === "incentive_points_data") {
        return "web";
      }
      return data.value;
    },
    viewErrorList(transactionId) {
      this.modalData.data = { transactionId: transactionId };
      this.$modal.show("eventModal", this.modalData);
    },
    getValueByKey(source, key) {
      if (!source) {
        return {
          text: ""
        };
      }
      return source.find(x => x.id === key);
    },
    formatThousandDecimal: val => {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    changeItemPerPageOptions: function(value) {
      this.pagingObj.limit = value;
      this.pagingObj.page = 1;
      this.actionGetTransactionList(this.getTransactionParams(true));
    },
    changePageOptions: function(value) {
      this.pagingObj.page = value;
      this.actionGetTransactionList(this.getTransactionParams(true));
    },
    getTransactionParams: function(keepData) {
      if (this.clientSftpId) {
        this.pagingObj.search = `client_ftp_id:${this.clientSftpId}`;
      }
      if (this.clientId) {
        this.pagingObj.search = `client_id:${this.clientId}`;
      }
      let pagingObject = Object.assign(
        {},
        ...Object.keys(this.pagingObj).map(k =>
          this.pagingObj[k] !== "" ? { [k]: this.pagingObj[k] } : {}
        )
      );

      if (this.selectedClientPanelId) {
        pagingObject.selected_client_panel_id = this.selectedClientPanelId;
      }
      return {
        params: pagingObject,
        keepData: keepData
      };
    },
    downloadFileUpload(file) {
      if (!this.canDownloadFile) {
        return;
      }
      const params = {
        file_name: file.item.file_name,
        file_id: file.item.file_id,
        employer_id: file.item.client_id,
        responseType: "stream",
        params: {
          file_path: file.item.file_path
        }
      };
      this.downloadFileUploadAction(params);
    },
    ...mapActions({
      actionGetTransactionList: ACTION_GET_TRANSACTION_LIST,
      downloadFileUploadAction: ACTION_DOWNLOAD_FILE_UPLOAD
    })
  },
  beforeMount() {
    this.actionGetTransactionList(this.getTransactionParams(false));
  },
  watch: {
    isReloadData: function(isReload) {
      if (isReload) {
        this.actionGetTransactionList(this.getTransactionParams(true));
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/transaction-associated/TransactionAssociated.vue